import React from "react"
import { Can } from '@src/utility/context/Can'

const CanCall = (props) => {
  // return props.children
  return (
    <Can I='call' a={props.action}>
      {props.children}
    </Can>
  )
}

export default CanCall